// Format dates in Italian dd/mm/yyyy. Accepts ISO strings, Date or YYYY-MM-DD.
export const formatItalianDate = (d) => {
  if (!d) return "";
  try {
    let s = typeof d === "string" ? d : d.toISOString();
    if (s.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(s)) {
      const [y, m, day] = s.slice(0, 10).split("-");
      return `${day}/${m}/${y}`;
    }
    const date = new Date(s);
    if (isNaN(date.getTime())) return s;
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}/${date.getFullYear()}`;
  } catch { return String(d); }
};

// Format dd/mm/yyyy HH:mm
export const formatItalianDateTime = (d) => {
  if (!d) return "";
  try {
    const date = new Date(d);
    if (isNaN(date.getTime())) return String(d);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mi = String(date.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${date.getFullYear()} ${hh}:${mi}`;
  } catch { return String(d); }
};
